var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24.0039C18.6274 24.0039 24 18.6313 24 12.0039C24 5.37649 18.6274 0.00390625 12 0.00390625C5.37258 0.00390625 0 5.37649 0 12.0039C0 18.6313 5.37258 24.0039 12 24.0039Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5499 16.4841C10.5519 16.1918 10.6403 15.9067 10.8041 15.6646C10.968 15.4225 11.1998 15.2344 11.4704 15.1239C11.741 15.0134 12.0383 14.9855 12.3247 15.0438C12.6111 15.102 12.8739 15.2438 13.0799 15.4511C13.2859 15.6585 13.4258 15.9222 13.4821 16.209C13.5384 16.4959 13.5086 16.7929 13.3963 17.0628C13.2839 17.3326 13.0942 17.5632 12.8511 17.7254C12.6079 17.8876 12.3221 17.9741 12.0299 17.9741C11.8335 17.9783 11.6384 17.9425 11.4563 17.8689C11.2742 17.7954 11.109 17.6856 10.9706 17.5463C10.8322 17.4069 10.7235 17.241 10.6512 17.0584C10.5789 16.8758 10.5444 16.6804 10.5499 16.4841ZM10.9099 8.13411L10.8299 5.97412H13.2199L13.1399 8.13411L12.7999 13.8541H11.2499L10.9099 8.13411Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcError);
export default __webpack_public_path__ + "static/media/ic_error.cb4a5a3621e51fb033adced3ddf292d2.svg";
export { ForwardRef as ReactComponent };